import { TileItem } from "../models/tileItem";

export const TILES: TileItem[] = [
  {
    id: 1,
    title: 'BD Marketing Contract Management',
    icon: 'business',
    description: 'In this, you can view and manage BD marketing contracts and organization setup documents.',
    color: '#e95263',
    viewLabel: 'BD Marketing Contract Management',
    viewLink: '/reference/contract-management',
    category: 'QHSE - Management'
  },
  {
    id: 2,
    title: 'Construction and Maintenance SOPs',
    icon: 'group',
    description: 'In this, you can watch and refer to standard operating procedures for construction and maintenance activities.',
    color: '#95c55f',
    viewLabel: 'Construction and Maintenance SOPs',
    viewLink: '/reference/construction-maintenance',
    category: 'QHSE - Management'
  },
  {
    id: 3,
    title: 'Customer Focus Risk Management',
    icon: 'security',
    description: 'In this, you can explore risk management documents focused on customer satisfaction and safety.',
    color: '#fe6e53',
    viewLabel: 'Customer Focus Risk Management',
    viewLink: '/reference/customerfocus-Riskmanagement',
    category: 'QHSE - Management'
  },
  {
    id: 4,
    title: 'QHSE',
    icon: 'health_and_safety',
    description: 'In this, you can review quality, health, safety, and environmental documentation.',
    color: '#546e7a',
    viewLabel: 'QHSE',
    viewLink: '/reference/qhse',
    category: 'QHSE - Management'
  },
  {
    id: 5,
    title: 'QHSE Related Documents for PAHWS2',
    icon: 'folder_shared',
    description: 'In this, you can find QHSE-related documents specifically for the PAHWS2 project.',
    color: '#546e7a',
    viewLabel: 'QHSE Related Documents for PAHWS2',
    viewLink: '/reference/documentsPAHWS2',
    category: 'QHSE - Management'
  },
  {
    id: 6,
    title: 'Services Property Management',
    icon: 'home_work',
    description: 'In this, you can access documents related to facility and property service management.',
    color: '#e95263',
    viewLabel: 'Services Property Management',
    viewLink: '/reference/servicesProperty',
    category: 'QHSE - Management'
  },
  {
    id: 7,
    title: 'Vendor Contracting SOP',
    icon: 'handshake',
    description: 'In this, you can review vendor-related contracting procedures, SOPs, and essential documentation.',
    color: '#95c55f',
    viewLabel: 'Vendor Contracting SOP',
    viewLink: '/reference/vendorContractSop',
    category: 'QHSE - Operations'
  },
  {
    id: 8,
    title: 'Workforce and Resourcing Process',
    icon: 'people_alt',
    description: 'In this, you can watch documents related to manpower planning and resource allocation.',
    color: '#fe6e53',
    viewLabel: 'Workforce Planning and Resourcing Process',
    viewLink: '/reference/workforceplanningResource',
    category: 'QHSE - Operations'
  },
  {
    id: 9,
    title: 'HSE Marketing Documentation (Training)',
    icon: 'school',
    description: 'In this, you can watch HSE marketing documents, training materials, and safety guides.',
    color: '#95c55f',
    viewLabel: 'HSE Marketing Documentation(Training-Admin)',
    viewLink: '/reference/hseMarketingDocumets',
    category: 'QHSE - Operations'
  },
  {
    id: 10,
    title: 'Infor',
    icon: 'insert_drive_file',
    description: 'In this, you can access various Infor platform-related documents and support files.',
    color: '#fe6e53',
    viewLabel: 'Infor related files',
    viewLink: '/reference/inforDocuments',
    category: 'QHSE - Operations'
  },
  {
    id: 11,
    title: 'Accreditation - Kuwait',
    icon: 'verified',
    description: 'In this, you can find accreditation documents specific to Kuwait operations.',
    color: '#546e7a',
    viewLabel: 'Accreditation - Kuwait',
    viewLink: '/reference/accreditationKuwait',
    category: 'QHSE - Operations'
  },
  {
    id: 12,
    title: 'Accreditation - UAE',
    icon: 'workspace_premium',
    description: 'In this, you can explore accreditation files for UAE-based certifications and audits.',
    color: '#e95263',
    viewLabel: 'Accreditation - UAE',
    viewLink: '/reference/accreditationUae',
    category: 'QHSE - Operations'
  }
];
